'use client';

var TIKTOK_EMBED_ENDPOINT = 'navi-api/api/tiktok';
var FIRST_EMBED = 0;

export { FIRST_EMBED, TIKTOK_EMBED_ENDPOINT };
//# sourceMappingURL=const.js.map
